import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M7.867 11.767H2"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M21.73 6.941S18.944 4 16.756 4c-5.104 0-8.562 3.62-8.562 3.62"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M15.597 8.222S2.25 7.77 2.13 8.55C1.914 9.929 2 18.2 2.172 18.706s10.895.874 12.139-.046c1.2-.873 1.372-3.722-1.459-2.849-2.53.781-.944 4.366 2.745 4.182"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M16.506 8.295c-.646-.257-2.582 1.287-4.767 1.853s-5.463 2.367-4.073 3.499 1.44-2.059 7.648.823c4.221 1.03 6.953-2.315 6.953-2.315"
    />
  </svg>
);
export const MoneyBackIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
